import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelServicePlan.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialModelState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import InputNumber from '../WSAControls/InputNumber/InputNumber';
import classNames from 'classnames';
import { isRequired, compareValues } from '../../utils';
import Cookies from 'js-cookie';
import DateTime from 'react-datetime';
import moment from 'moment-timezone';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';


const ModelServicePlan = ({
  ModelCategoryId,
  ModelServicePlanId,
  ModelId,
  saveModelServicePlan,
  modelServicePlan = { ...initialModelState.modelManager.selectedModel.ServicePlans },
  changeModelServicePlan,
  cancelHandler,
  checklistTemplate,
  currentTimezone,
  setEditHandler,
  intl
}) => {
  let IsEdit = false;
  const [localformErrors, setFormErrors] = useState({});
  const [commandId, setCommandId] = useState(0);
  const [active, setActive] = useState(false);
  const [showApplySchedule, setShowApplySchedule] = useState(true);
  const [updatedDateTime, setUpdatedDateTime] = useState(null);
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  if (ModelServicePlanId) {
    IsEdit = true;
  }

  // Update redux store
  const setLocalModelServicePlan = currentState => {
    changeModelServicePlan(currentState);
  };

  let widgetCode = IsEdit ? 'MODELSERVICEPLANSEDIT' : 'MODELSERVICEPLANSADD';

  const checklistTemplatesOptions = () => {
    let checklistTemplatesData = [];
    checklistTemplate.ChecklistTemplates.forEach(element => {
      if (
        modelServicePlan &&
        modelServicePlan.ServicePlansList.filter(x => x.ChecklistTemplateId === element.ChecklistTemplateId).length === 1
      ) {
        element.isDisabled = true;
      } else {
        element.isDisabled = false;
      }
      checklistTemplatesData.push({
        ...element,
        label: element.Name,
        value: element.ChecklistTemplateId
      });
    });

    let sortedData = checklistTemplatesData.sort(compareValues('label'));
    return [{ value: 0, label: 'None' }, ...sortedData];
  };

  const disablePastDates = current =>
    current.isAfter(
      moment()
        .tz(currentTimezone)
        .subtract(1, 'day')
    );

  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = modelServicePlan.SelectedServicePlan;
    saveData.PerformDelete = false;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveData.ModelId = ModelId
    saveData.ModelCategoryId = ModelCategoryId

    if (!IsEdit) {
      saveData.ModelServicePlanId = 0;
      saveData.ModelId = ModelId;
      saveData.GuidIdentifier = uuidv4();
    }

    saveModelServicePlan(saveData, widgetCode, false);
  };

  let selServicePlanObj = null;
  if (modelServicePlan.SelectedServicePlan.ChecklistTemplateId) {
    selServicePlanObj = checklistTemplate.ChecklistTemplates.find(
      x => x.ChecklistTemplateId === modelServicePlan.SelectedServicePlan.ChecklistTemplateId
    );
  }

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;
    if (
      !modelServicePlan ||
      !modelServicePlan.SelectedServicePlan ||
      isRequired(modelServicePlan.SelectedServicePlan.Name, 1)
    ) {
      formErrors.Name = intl.formatMessage({
        id: 'model.servicePlanNameRequired',
        defaultMessage: 'Service Name is required'
      });
      isValid = false;
    }

    if (
      !modelServicePlan ||
      !modelServicePlan.SelectedServicePlan ||
      isRequired(modelServicePlan.SelectedServicePlan.Description, 1)
    ) {
      formErrors.Description = intl.formatMessage({
        id: 'model.servicePlanDesriptionRequired',
        defaultMessage: 'Service description is required'
      });
      isValid = false;
    }

    if (
      !modelServicePlan ||
      !modelServicePlan.SelectedServicePlan ||
      !modelServicePlan.SelectedServicePlan.ChecklistTemplateId ||
      isRequired(modelServicePlan.SelectedServicePlan.ChecklistTemplateId, 1)
    ) {
      formErrors.ChecklistTemplateId = intl.formatMessage({
        id: 'model.servicePlanCheckListTemplateRequired',
        defaultMessage: 'Checklist template is required'
      });
      isValid = false;
    }

    if (
      !modelServicePlan ||
      !modelServicePlan.SelectedServicePlan ||
      isRequired(modelServicePlan.SelectedServicePlan.ScheduleByPeriod, 1)
    ) {
      formErrors.ScheduleByPeriod = intl.formatMessage({
        id: 'model.servicePlanSchedulePeriodRequired',
        defaultMessage: 'Schedule Period'
      });
      isValid = false;
    } else {
      if (
        modelServicePlan.SelectedServicePlan &&
        modelServicePlan.SelectedServicePlan.ScheduleByPeriod !== undefined &&
        modelServicePlan.SelectedServicePlan.ScheduleByPeriod !== '' &&
        modelServicePlan.SelectedServicePlan.ScheduleByPeriod < 1
      ) {
        formErrors.ScheduleByPeriod = intl.formatMessage({
          id: 'model.servicePlanSchedulePeriodValidate',
          defaultMessage: 'Schedule Period has to be more than 0'
        });
        isValid = false;
      }
    }

    if (
      !modelServicePlan ||
      !modelServicePlan.SelectedServicePlan ||
      !modelServicePlan.SelectedServicePlan.StartDateTime ||
      isRequired(modelServicePlan.SelectedServicePlan.StartDateTime, 1)
    ) {
      let respData = validateDate();
      if (!respData.validDate) {
        if (respData.convertedDate) {
          formErrors.StartDateTime = intl.formatMessage({
            id: 'model.servicePlanStartDateShouldBeGreaterThanOrEqualToTodaysDate',
            defaultMessage: "Start date must be greater than or equal to today's date"
          });
        } else {
          formErrors.StartDateTime = intl.formatMessage({
            id: 'model.servicePlanStartDateRequired',
            defaultMessage: 'Valid start date is required'
          });
        }

        isValid = false;
      } else {
        modelServicePlan.SelectedServicePlan.StartDateTime = respData.convertedDate.unix();
      }
    }
    setFormErrors(formErrors);
    return isValid;
  };

  //clean up
  useEffect(() => {
    return () => {
      setEditHandler(-1);
    };
  }, []);

  //on control value change
  const onChange = e => {
    setShowApplySchedule(false);
    setLocalModelServicePlan({
      ...modelServicePlan,
      SelectedServicePlan: { ...modelServicePlan.SelectedServicePlan, [e.target.name]: e.target.value }
    });
  };

  const onDropdownChange = e => {
    setShowApplySchedule(false);
    setLocalModelServicePlan({
      SelectedServicePlan: { ...modelServicePlan.SelectedServicePlan, ChecklistTemplateId: e.value }
    });
  };

  const onDateChange = newVal => {
    //Keeping this value in global variable to process it during  saving if newVal is string.
    setUpdatedDateTime(newVal);
    let dateTime = null;
    if (newVal && newVal.unix) {
      dateTime = newVal.unix();
    }
    setShowApplySchedule(false);
    setLocalModelServicePlan({
      SelectedServicePlan: { ...modelServicePlan.SelectedServicePlan, StartDateTime: dateTime }
    });
  };

  const validateDate = () => {
    //Converting datetime to unix time format if updatedDateTime != null and  modelServicePlan.SelectedServicePlan.StartDateTime is null
    let respData = {
      convertedDate: null,
      validDate: false
    };
    if (!modelServicePlan.SelectedServicePlan.StartDateTime && updatedDateTime != null) {
      let convertedDate = moment(updatedDateTime);
      if (convertedDate.isValid() && convertedDate.unix() && convertedDate.unix() > 0) {
        if (
          moment()
            .startOf('day')
            .unix() > convertedDate.unix()
        ) {
          respData.convertedDate = convertedDate;
          return respData;
        }
        setLocalModelServicePlan({
          SelectedServicePlan: { ...modelServicePlan.SelectedServicePlan, StartDateTime: convertedDate.unix() }
        });
        respData.convertedDate = convertedDate;
        respData.validDate = true;
        return respData;
      }
    }
    return respData;
  };

  let ddlClass = localformErrors && localformErrors.ChecklistTemplateId ? s.ddlError : '';

  const dialogTitle = intl.formatMessage({
    id: 'modelServicePlan.confirmApplySchedule',
    defaultMessage: 'Do you wish to create the service schedules to all units for this model from the starting date?'
  });

  const handleClose = () => setActive(false);

  const handleCommand = commandId => {
    setActive(true);
    setCommandId(commandId);
  };
  const handleConfirm = () => {
    if (!validateInput()) {
      return;
    }
    handleClose();

    let saveData = modelServicePlan.SelectedServicePlan;
    saveData.IsEdit = IsEdit;
    saveData.ModelCategoryId = ModelCategoryId;
    saveData.ModelId = ModelId;
    saveData.ApplyServiceSchedules = true;
    saveData.OrganisationId = Cookies.get(`selectedorganisationid-${envName}`);
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;

    saveModelServicePlan(saveData, widgetCode, true);
  };

  return (
    <div className={s.modelServicePlan}>
      <div className={s.contentWrapper}>
        <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
        <Form>
          <div className={s.editScreenRow}>
            <Row>
              <Col lg={4}>
                <Form.Group controlId="formServicePlanName">
                  <Form.Label>
                    <FormattedMessage id="modelServicePlan.name" defaultMessage="Service Name" />
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="Name"
                    onChange={onChange}
                    value={modelServicePlan.SelectedServicePlan.Name}
                    className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                  />
                  {localformErrors && localformErrors.Name && (
                    <p role="alert" className={s.error}>
                      {localformErrors.Name}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group controlId="formServicePlanDesc">
                  <Form.Label>
                    <FormattedMessage id="modelServicePlan.description" defaultMessage="Description" />
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="Description"
                    onChange={onChange}
                    value={modelServicePlan.SelectedServicePlan.Description}
                    className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                  />
                  {localformErrors && localformErrors.Description && (
                    <p role="alert" className={s.error}>
                      {localformErrors.Description}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group controlId="formServicePlanCheckList">
                  <Form.Label>
                    <FormattedMessage id="modelServicePlan.checklistName" defaultMessage="Checklist Template" />
                  </Form.Label>
                  <Dropdown
                    id="formServicePlanName"
                    dataArray={checklistTemplatesOptions()}
                    controlData={{ placeholderText: 'Select Template', customClassName: ddlClass }}
                    onDropdownChange={onDropdownChange}
                    selectedOption={checklistTemplatesOptions().filter(
                      option => option.value === modelServicePlan.SelectedServicePlan.ChecklistTemplateId
                    )}
                    disabled={IsEdit}
                    data-unittest="formServicePlan"
                  />
                  {localformErrors && localformErrors.ChecklistTemplateId && (
                    <p role="alert" className={s.error}>
                      {localformErrors.ChecklistTemplateId}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group controlId="formServicePlanScheduleByPeriod">
                  <Form.Label>
                    <FormattedMessage id="modelServicePlan.scheduleByPeriod" defaultMessage="Schedule Period " /> (
                    {modelServicePlan.SelectedServicePlan.ScheduleBy})
                  </Form.Label>
                  <InputNumber
                    name="ScheduleByPeriod"
                    step="1"
                    onInputChange={onChange}
                    value={modelServicePlan.SelectedServicePlan.ScheduleByPeriod}
                    id="formServicePlanValue"
                    customClassName={`${localformErrors && localformErrors.ScheduleByPeriod ? s.formControlError : ''}`}
                  />
                  {localformErrors && localformErrors.ScheduleByPeriod && (
                    <p role="alert" className={s.error}>
                      {localformErrors.ScheduleByPeriod}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} lg={3}>
                <Form.Group controlId="formDueDate" className={s.customDtPicker}>
                  <Form.Label>
                    <FormattedMessage id="modelServicePlan.startDateTime" defaultMessage="Start Date" />
                  </Form.Label>

                  <DateTime
                    isValidDate={disablePastDates}
                    onChange={m => onDateChange(m)}
                    timeFormat="HH:mm:ss"
                    dateFormat="DD-MMM-YYYY"
                    value={
                      modelServicePlan.SelectedServicePlan.StartDateTime
                        ? moment.unix(modelServicePlan.SelectedServicePlan.StartDateTime).tz(currentTimezone)
                        : null
                    }
                    closeOnSelect={true}
                  />
                  {localformErrors && localformErrors.StartDateTime && (
                    <p role="alert" className={s.error}>
                      {localformErrors.StartDateTime}
                    </p>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={ModelServicePlanId ? 8 : 4} xs={12}>
                <Button
                  variant="primary"
                  className={classNames(s.margin5, s.btnSaveChanges)}
                  onClick={submitForm}
                  noValidate
                  data-unittest="saveData"
                >
                  <FormattedMessage id="modelVariantManagement.saveModelVariantThreshold" defaultMessage="SAVE" />
                </Button>
                <Button
                  variant="outline-secondary"
                  className={classNames(s.btnCancel)}
                  onClick={cancelHandler}
                  noValidate
                  data-unittest="saveCancel"
                >
                  <FormattedMessage id="modelVariantManagement.cancelModelVariantThreshold" defaultMessage="CANCEL" />
                </Button>
                {IsEdit && showApplySchedule && (
                  <Button
                    variant="primary"
                    className={classNames(s.margin5, s.btnApplyChanges)}
                    onClick={() => handleCommand()}
                    noValidate
                    data-unittest="saveData"
                  >
                    <FormattedMessage id="modelServicePlan.applyScheduleModelVariantThreshold" defaultMessage="APPLY SCHEDULES" />
                  </Button>
                )}
              </Col>
              <Col lg={ModelServicePlanId ? 7 : 5}></Col>
            </Row>
          </div>
        </Form>
      </div>
    </div>
  );
};


ModelServicePlan.propTypes = {
  saveModelServicePlan: PropTypes.func.isRequired,
  changeModelServicePlan: PropTypes.func.isRequired,
  modelServicePlan: PropTypes.object.isRequired,
  checklistTemplate: PropTypes.object,
  cancelHandler: PropTypes.func.isRequired
};

export default injectIntl(ModelServicePlan);
